import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import { t } from 'i18next';
import HowItWorks from '../../Components/CommonSections/HowItWorks';
import LazySection from '../Home/LazySection';
import PopularPujas from '../../Components/CommonSections/PopularPujas';
import FAQ from '../../Components/CommonSections/FAQ';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import BlogCarousel from '../../Components/BlogsSection/BlogsSection';
import { GetUserModel } from '../../ApiServices/Profile/ProfileApi';
import ComingSoonModal from '../../Components/ComingSoonModal';
import DownloadApp from '../../Components/DownLoadApp/DownloadApp';
import toast from 'react-hot-toast';
import LoginPopUp from '../../Components/LoginPopup';
import { LoaderContext } from '../../AuthContext/AuthContext';
import { landingPageEnglishContent, landingPageMarathiContent } from '../../Components/enum';
import favIcon from '../../assets/images/Fav.png'
const PujaServicesLandingPage = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { servicename } = useParams();
    const { setLoader, selectedLanguageID, isLanguageUpdate } = useContext(LoaderContext);

    const ItemAddedToast = () => toast("User fetched");
    const [showOpenLoginModal, setShowOpenLoginModal] = useState(false);
    const [showExitIntentModal, setShowExitIntentModal] = useState(false);
    const [showComingSoonModal, setShowComingSoonModal] = useState(false);
    const [slug, setSlug] = useState("");

    const [data, setData] = useState(landingPageEnglishContent)
    const serviceData = data?.find((item) => item.serviceName === servicename);

    useEffect(() => {
        const path = location.pathname;

        if (path.startsWith("/services/")) {
            const slugPart = path.replace("/services/", "");
            setSlug(slugPart || "default");

            if (slugPart === "horoscope") {
                setShowExitIntentModal(false);
                return; // Stop further execution
            }

            const modalClosed = sessionStorage.getItem("exit_modal_closed");

            // Scroll event listener
            const handleScroll = () => {
                if (!modalClosed && window.scrollY > 300) {
                    if (servicename !== 'puja-kit-services') {

                        setShowExitIntentModal(true);
                    }
                    window.removeEventListener("scroll", handleScroll); // Remove listener after showing modal
                }
            };

            window.addEventListener("scroll", handleScroll);

            return () => {
                window.removeEventListener("scroll", handleScroll);
            };
        } else {
            setShowExitIntentModal(false);
        }
    }, [location]);

    useEffect(() => {
        if (Number(selectedLanguageID) === 3) {
            setData(landingPageMarathiContent)
        } else {
            setData(landingPageEnglishContent)
        }

    }, [selectedLanguageID])

    const GetUserModelData = async (value) => {
        const userID = JSON.parse(localStorage.getItem("userID"));
        if (userID === null || userID === undefined) {
            setShowOpenLoginModal(true);
        }
        try {
            const response = await GetUserModel(userID);
            if (response?.ResponseCode == 0) {

                const ModelData = response.DATA || [];
                if (
                    ModelData[0]?.DOB === null ||
                    ModelData[0]?.DOB === undefined ||
                    ModelData[0]?.DOB === ""
                ) {
                    ItemAddedToast();

                } else {
                    navigate(value?.route);
                }
            } else {
                console.error(
                    "Error fetching data: ",
                    response?.data?.data?.statusCode
                );
            }
        } catch (error) {
            console.error("Error", error);
        }
    };

    return (
        <>
            {/* Page header with banner */}
            <section className="page-header">
                <div
                    className="page-header__bg_serviceBanner"
                    style={{ backgroundImage: `url(${serviceData?.serviceBannerImg})` }}
                ></div>
                <div className="container">
                    <h1
                        className="page-header__title bw-split-in-left"

                    >
                        {serviceData.headerName}
                    </h1>
                </div>
            </section>

            {/* SEO Tags */}
            <Helmet>
                <link rel="icon" type="image/png" href={favIcon} />
                <title>{serviceData.metaTitle}</title>
                <meta name="description" content={serviceData.metaDescription} />
                <link rel="canonical" href={serviceData.cannonicalLink} />

                {/* Open Graph tags */}
                <meta property="og:title" content={serviceData.metaData.title} />
                <meta
                    property="og:description"
                    content={serviceData.metaData.description}
                />
                <meta property="og:image" content={serviceData.metaData.image} />
                <meta property="og:url" content={serviceData.metaData.url} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content={serviceData.metaData.siteName} />
                <meta
                    property="og:locale"
                    content={serviceData.metaData.locale || "en_IN"}
                />

                {/* Twitter Card Meta Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={serviceData.metaData.title} />
                <meta
                    name="twitter:description"
                    content={serviceData.metaData.description}
                />
                <meta name="twitter:image" content={serviceData.metaData.image} />

                {/* Breadcrumb JSON-LD Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify(serviceData.breadcrumbSchema)}
                </script>

                {/* WebPage JSON-LD Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify(serviceData.webpageSchema)}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify(serviceData.faqSchema)}
                </script>
            </Helmet>

            {/*  TagLine Short description */}
            <section>
                <div className="container">
                    <div className="row" style={{ marginBottom: "20px" }}>
                        <div
                            className="col-md-12 mt-3 wow fadeInRight d-flex"
                            serviceData-wow-delay="200ms"
                        >
                            <div
                                className="about-one__content"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    padding: '0px'
                                }}
                            >
                                <div className="sec-title text-left">
                                    <h6 className="sec-title__tagline bw-split-in-right">
                                        <img className=" tagline-img" src={pandit} alt="" />
                                        {serviceData.tagLine}
                                    </h6>

                                    <h3 className="sec-title__title bw-split-in-left">
                                        {serviceData.sectionTitle}
                                    </h3>
                                </div>
                                <p
                                    className="about-one__content__text"
                                    style={{ textAlign: "justify", padding: '0px' }}
                                >
                                    {serviceData.mainContent}
                                </p>

                                <div className="col-6 wow about-one__content">
                                    {" "}
                                    <Link to={serviceData.route}>
                                        <button className="careox-btn"> {t('Book Now')}  </button>
                                    </Link>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How It Works */}
            <LazySection><HowItWorks serviceData={serviceData} /></LazySection>

            {/* Popular Pujas */}
            {(serviceData?.pujaSubServiceID !== null && serviceData?.pujaSubServiceID !== undefined && serviceData?.pujaServiceID !== null && serviceData?.pujaServiceID !== undefined) && (

                <LazySection><PopularPujas pujaSubServiceID={serviceData?.pujaSubServiceID} pujaServiceID={serviceData?.pujaServiceID} moduleName="RemedyPuja" /></LazySection>
            )}

            {/* WhyChooseUS */}

            {serviceData?.whychooseUs?.length > 0 && (

                <section
                    className="py-5 text-center"
                    style={{ backgroundColor: "#f1f6f7" }}
                >
                    <div
                        className="container"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <h6
                            className="sec-title__tagline bw-split-in-right"
                            style={{ color: "#A52444" }}
                        >
                            <img className=" tagline-img" src={pandit} alt="" />
                            {t("Why Choose Us")}
                        </h6>

                        <h3 className="sec-title__title bw-split-in-left">
                            {serviceData?.whychooseUsTitle}
                        </h3>

                        <div
                            className="d-flex flex-wrap justify-content-center serviceLandingPage-WhyChooseUs"

                        >
                            {serviceData?.whychooseUs?.map((reason, index) => (
                                <div
                                    key={index}
                                    className="card shadow-sm border-0 p-4 text-center WhyChooseUs-reasons"

                                >
                                    <div className="mb-3">{reason.icon}</div>
                                    <h5 className="fw-bold mb-2">{reason.title}</h5>
                                    <p
                                        style={{
                                            textAlign: "left",
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                            hyphens: "auto",
                                            lineHeight: "1.6",
                                        }}
                                    >
                                        {reason.description?.replace(/\s+/g, " ")}
                                    </p>

                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}



            {/* Download App  */}
            <LazySection><DownloadApp languageID={selectedLanguageID == 3 ? 1 : null} /></LazySection>



            {/* FAQ'S */}
            <LazySection><FAQ moduleName="RemedyPuja" serviceData={serviceData} slug={slug} showExitIntentModal={showExitIntentModal} setShowExitIntentModal={setShowExitIntentModal} /></LazySection>

            {/* Blogs Section */}
            <LazySection><BlogCarousel /></LazySection>

            {/* Popup If Login needed */}
            <LoginPopUp
                show={showOpenLoginModal}
                onHide={() => setShowOpenLoginModal(false)}
                onConfirm={() => setShowOpenLoginModal(false)}
            />

            {/* Showing Coming soon popup if service is not Completed  */}
            <ComingSoonModal
                show={showComingSoonModal}
                onClose={() => setShowComingSoonModal(false)}
            />
        </>
    )
}

export default PujaServicesLandingPage
